/**
 * @deprecated
 */
export enum AccountType {
  Admin = 'admin',
  Customer = 'customer',
  User = 'user',
}
